import { useUuid } from "@configura/web-ui";
import React from "react";
import styles from "./index.module.css";

interface Props {
	parentFunction: React.Dispatch<React.SetStateAction<string>>;
}
const FilterInput: React.FC<Props> = (props: Props) => {
	const { parentFunction } = props;

	const uniqueId = useUuid();

	return (
		<>
			<label htmlFor={uniqueId} className={styles.filterLabel}>
				Filter
			</label>
			<input
				id={uniqueId}
				type="text"
				className={styles.filterInput}
				placeholder="Start typing..."
				onChange={(e) => {
					parentFunction(e.target.value);
				}}
			/>
		</>
	);
};

export default FilterInput;
